<div>
  <div class="search-form" [ngClass]="isAllMFSearch ? 'symbol-filter' : ''">
    <div class="symbol-search-bar">
      <input
        #symbolInput
        #trigger="cdkOverlayOrigin"
        (focusin)="handleFocus($event)"
        (input)="handleInput($event)"
        (keydown)="handleKeydown($event)"
        (blur)="checkIfSymbolIsBlank()"
        autocomplete="off"
        cdk-overlay-origin
        class="client-search sdps-input"
        [ngClass]="{
          'ag-text-field-input': isAllMFSearch,
          'input-background-active': selectedValue && !symbolInput.disabled && !viewMode
        }"
        type="text"
        [value]="selectedValue ? selectedValue : ''"
        [placeholder]="placeholder ? placeholder : ''" />
        <span>
          @if (symbolInput.value.length >= 1 && !symbolInput.disabled) {
            <i
              class="sdps-text-secondary delete-icon-padding"
              (click)="clearSearch()"
              ><img class="deleteIcon" [src]="deleteIcon" /></i
              >
          }</span>
          <span>
            @if (symbolInput.value.length === 0 && !symbolInput.disabled) {
              <i
                class="sch-search sdps-text-secondary symbsearch-icon-padding"
                ></i
                >
              }</span>
            </div>

            <ng-template
              [cdkConnectedOverlayOpen]="showPanel"
              [cdkConnectedOverlayOrigin]="trigger"
              [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
              [cdkConnectedOverlayPositions]="positions"
              cdk-connected-overlay>
              <div class="symbol-search-container">
                <div
                  class="scroll-container"
                  style="min-height: 200px"
                  [ngStyle]="{ 'max-height.px': panelHeight, 'width.px': viewMode === ('CREATE' || 'EDIT') ? '550' : '450' }">
                  <div class="search-content">
                    <div #panel [ngClass]="isLoading ? 'default' : ''" class="search-panel">
                      @if (viewMode === 'CREATE') {
                        <div class="symbolSearchMsg">
                          An account must hold a position in a fund before you can create an instruction
                        </div>
                      }
                      @if (isLoading) {
                        <div>
                          <sdps-spinner type="loading" show-by-default="true" id="symbol-search-spinner"></sdps-spinner>
                        </div>
                      }
                      @if (!isLoading) {
                        @if (statusMessage) {
                          <div class="error">{{ statusMessage }}</div>
                        }
                        @if (
                          (filteredFunds.length == 0 && searchCriteria.accountId !== '') ||
                          (isAllMFSearch && filteredFunds.length == 0 && !isLoading)
                          ) {
                          <ng-container *ngTemplateOutlet="noSearchResultsFound"></ng-container>
                        }
                        <div class="funds">
                          <ul>
                            <li>
                              @if (filteredFunds.length) {
                                <ng-container *ngTemplateOutlet="symbolTemplate"></ng-container>
                              }
                            </li>
                          </ul>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </ng-template>

            <ng-template #noSearchResultsFound>
              <div class="no-results-header">
                <p>No results</p>
                <br />
              </div>
            </ng-template>
            <ng-template #symbolTemplate>
              <div>
                <table class="symbol-search-results-table">
                  <tbody>
                    @for (fundRecord of filteredFunds; track fundRecord; let i = $index) {
                      <tr
                        (selected)="select(fundRecord)"
                        [type]="symbolRecordType"
                        [value]="fundRecord"
                        search-result-row>
                        <div class="flex-container symbolSearchBorder">
                          <div class="flex-row top-row">
                            <div
                              id="symbol-fund"
                              [className]="viewMode === ('CREATE' || 'EDIT') ? 'col-2' : 'col-2'"
                            [innerHtml]="fundRecord.fundSymbol | highlight: symbolInput.value"></div>
                            <div
                              id="symbol-name"
                              title="fundRecord.fundName"
                              [className]="viewMode === ('CREATE' || 'EDIT') ? 'col-7' : 'col-8'"
                              [innerHtml]="fundRecord.fundName | highlight: symbolInput.value"
                    [ngStyle]="{
                      'padding-left.px': viewMode === ('CREATE' || 'EDIT') ? '' : '0',
                      'max-width.ch': viewMode === ('CREATE' || 'EDIT') ? '' : '50'
                    }"></div>
                            @if (fundRecord.status !== '' && viewMode === 'CREATE') {
                              <div
                                id="symbol-status"
                                [className]="viewMode === ('CREATE' || 'EDIT') ? 'col-3' : 'col-3'"
                              [innerHtml]="'Instruction exists'"></div>
                            }
                          </div>
                        </div>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </ng-template>
          </div>
        </div>
